import React, { useEffect, useState, Fragment, useReducer } from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import { hashHistory } from 'react-router';
import SqftFeaturesPopupApplyButton from "./sqftFeaturesPopupApplyButton";
import { changeSqftFeaturesPopup } from "../../../actions/sqftFunctions";
import SqftFeaturesPopupBody from "./sqftFeaturesPopupBody";
import { getParsedSqftData, getSimilarFeatureGroup } from "./parseSqftData";
import { removeFromCart, setCameFromPage } from "../../../actions/actionFunctions";
import AllFeaturesChecker from "../../visComponents/allFeaturesChecker";
import MaterialSpinner from "../../ui/materialSpinner";
import workspace from "../../sqft/components/canvas/core/workspace";
import {addUUIDToCartItems, computeAddedFeatures} from "./utils/computeAddedFeatures";
import {checkWizardConflictingSteps} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctionsConflictingLogic";
import {setSQFTCartItemsToAdd} from "../../../actions/sqftResourceFunctions";
import {setWizardConflictSteps} from "../../../actions/wizardFunctions";
import {SQFT_FEATURES} from "../../sqft/constants";

const SqftFeaturesPopup = (props) => {
  const { changeSqftFeaturesPopup, sqftFeaturesPopup, intl, fabricatorData, sqftFromFeature, cartItems, setCameFromPage,
    stonePricing, quotes, removeFromCart, setWizardConflictSteps, setSQFTCartItemsToAdd, sqftCartItems} = props;
  const { opened, sqftPassedData } = sqftFeaturesPopup;
  const [parentsLists, setParentsLists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [, forceUpdate] = useReducer(x => x + 1, 0);

  const edgesFeatureGroup = opened ? getSimilarFeatureGroup("edges") : null;
  const edgesReceived = !edgesFeatureGroup || edgesFeatureGroup.part.allFeaturesReceived;

  useEffect(() => {
    if (opened && sqftPassedData && edgesReceived) {
      setLoading(true);
      removeDeletedInSQFTFeatures();
      //rebuildQuoteLists();
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sqftPassedData, edgesReceived]);

  useEffect(() => {
    if (opened && workspace.intl) {
      rebuildQuoteLists();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quotes]);

  useEffect(() => {
    if (opened && workspace.intl && parentsLists.length > 0) {
      checkForConflictSteps();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parentsLists]);

  const rebuildQuoteLists = () => {
    const quoteLists = quotes.map((quote, quoteIndex) => {
      return {
        quoteIndex,
        quote,
        qtCatName: quote.qtCatName,
        ...getParsedSqftData(
          quote.sqFtCalcData,
          sqftFeaturesPopup.previouslyAddedSqftFeatures,
          intl,
          fabricatorData,
          cartItems,
          sqftFromFeature,
          quoteIndex,
          quote.room,
          stonePricing,
        )
      };
    });
    setParentsLists([...quoteLists]);
  };

  const checkForConflictSteps = () => {
    setSQFTCartItemsToAdd([]);
    for (const parentsList of parentsLists) {
      const {addedFeatures} = computeAddedFeatures([parentsList]);
      const tempCartItems = addUUIDToCartItems(addedFeatures);
      const cartItemsWithoutSQFTFeatures = cartItems.filter(cartItem => !cartItem.sqftIds?.length && !cartItem.sqftId);
      const cartItemsAndSQFTTempCartItems = [...tempCartItems, ...cartItemsWithoutSQFTFeatures];
      console.log("tempCartItems", tempCartItems);
      console.log("cartItemsAndSQFTCartItems", cartItemsAndSQFTTempCartItems);
      const cartItemsAndSQFTTempCartItemsWithoutSlabs = cartItemsAndSQFTTempCartItems.filter(cartItem => cartItem.partId !== SQFT_FEATURES.slabs);
      let {wizardConflictingSteps} = checkWizardConflictingSteps(cartItemsAndSQFTTempCartItemsWithoutSlabs);

      if (wizardConflictingSteps?.length > 0) {
        wizardConflictingSteps = wizardConflictingSteps?.map(confStep => {
          if ((!confStep.wizardGroupId || !Number.isInteger(confStep.stepIndex)) && confStep.cartFeature) {
            const alreadyAddedFeature = sqftCartItems.find(oldCartItem => {
              return oldCartItem?.cartFeature?.dbFeature?.id === confStep.cartFeature.dbFeature?.id
            });
            if (alreadyAddedFeature && alreadyAddedFeature.fromWizardGroupId) {
              confStep.wizardGroupId = alreadyAddedFeature.fromWizardGroupId;
              confStep.stepIndex = alreadyAddedFeature.fromWizardStep;
            }
          }
          delete confStep.cartFeature; // no need to keep it there, we have cartItemId if needed
          return confStep;
        });
        for (const tempCartItem of tempCartItems) {
          const confStep = wizardConflictingSteps?.find(confStep => confStep.cartItemId === tempCartItem.id)
          if (confStep) {
            tempCartItem.fromWizardGroupId = confStep.wizardGroupId
            tempCartItem.fromWizardStep = confStep.stepIndex
          }
        }
        setWizardConflictSteps(wizardConflictingSteps);
        setSQFTCartItemsToAdd(tempCartItems);
        //handleOpenModalFix({changeWizardStepRoute, wizardConflictingSteps});
      }
      console.log("wizardConflictingSteps", wizardConflictingSteps);
    }
  };

  if (!opened) {
    return null;
  }

  const removeDeletedInSQFTFeatures = () => {
    if (sqftPassedData.removedFeatures) {
      const removedFeatures = cartItems.filter(cartItem => {
        return sqftPassedData.removedFeatures.includes(cartItem.sqftId);
      });
      removedFeatures.forEach(cartItem => removeFromCart(cartItem));
    }
  };

  const closePopup = () => {
    changeSqftFeaturesPopup({
      opened: false,
      sqftPassedData: null
    });
  };

  const backButtonClick = () => {
    setCameFromPage("materials");
    hashHistory.push("sqft");
    closePopup();
  };

  return (
    <Fragment>
      <div className="ui-popup__header">
          <span className="ui-popup__header-title">
            <FormattedMessage id="sqftFeaturesPopup.title" />
          </span>
        <button className="ui-close contract-popup__close" onClick={closePopup} />
      </div>
      {!edgesReceived && edgesFeatureGroup ? (
        <div className="ui-popup__body ui-popup__body--relative">
          <AllFeaturesChecker subPart={edgesFeatureGroup} callBack={() => forceUpdate(1)} loaderOnly={true} />
        </div>
      ) : (
        loading ? (
          <MaterialSpinner />
        ) : (
          <SqftFeaturesPopupBody parentsLists={parentsLists}
                                 setParentsLists={setParentsLists}
                                 rebuildQuoteLists={rebuildQuoteLists} />
        )
      )}
      <div className="ui-popup__footer">
        <div className="ui-popup__footer-right">
          <button className="ui-button2 ui-button2--blue" onClick={backButtonClick}>
            <FormattedMessage id="assignPopup.backButton" />
          </button>
          <SqftFeaturesPopupApplyButton parentsLists={parentsLists} closePopup={closePopup} />
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (store) => {
  const { sqftFeaturesPopup, sqftFromFeature } = store.sqftState;
  const { cartItems } = store.cartState;
  const { stonePricing } = store.serverState;
  const { sqftCartItems } = store.sqftResourceState;
  return {
    sqftFeaturesPopup,
    sqftFromFeature,
    fabricatorData: store.fabricatorState,
    cartItems,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    stonePricing,
    quotes: store.quotesState.quotes,
    fabricatorSettings: store.fabricatorState.settings,
    sqftCartItems,
  };
};
const mapDispatchToProps = {
  changeSqftFeaturesPopup,
  setCameFromPage,
  removeFromCart,
  setWizardConflictSteps,
  setSQFTCartItemsToAdd,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftFeaturesPopup)
);
